import { IScrollUpdatePosition, ScrollActionTypes } from "./scrollTypes"

export const scrollUpdatePosition = (type: ScrollActionTypes, position: number): IScrollUpdatePosition => {
  return {
    type: type,
    payload: position
  }
}
